var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoldenStar = function SvgGoldenStar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0L16.2152 6.18578L23.3672 8.30616L18.8203 14.2496L19.0253 21.7458L12.0001 19.2333L4.97479 21.7458L5.17979 14.2496L0.632935 8.30616L7.7849 6.18578L12.0001 0Z",
    fill: "#FBC22F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 12.0091L0.632935 8.30593L7.7849 6.18555L12.0001 12.0091Z",
    fill: "#FCD97D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0L16.2153 6.18578L12.0001 12.0094V0Z",
    fill: "#FCD97D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 12.0094L5.17979 14.2496L0.632935 8.30615L12.0001 12.0094Z",
    fill: "#E6A705"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 12.0094L23.3673 8.30615L18.8204 14.2496L12.0001 12.0094Z",
    fill: "#E6A705"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.0093L19.0253 21.7458L12 19.2332L4.97473 21.7458L12 12.0093Z",
    fill: "#E6A705"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoldenStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/golden-star.6c5e3ac42f50aced4e215517e128e4e6.svg";